const DOMElements = {
    mainDiv: () => document.querySelector(`div.fly-offer`),
    loanValue: () => document.querySelector(`strong[data-id="flyoffer-loan"]`),
    splitsValue: () => document.querySelector(`strong[data-id="flyoffer-splits"]`),
    tanValue: () => document.querySelector(`strong[data-id="flyoffer-tan"]`),
    taegValue: () => document.querySelector(`strong[data-id="flyoffer-taeg"]`),
    installmentValue: () => document.querySelector(`strong[data-id="flyoffer-imp-rata"]`),
    closeFlyOfferButton: () => document.querySelector(`button#closeFlyOffer`),
    startButton: () => document.querySelector(`a[data-id="start-button"]`),
    continueButton: () => document.querySelector(`a#btn-goto-form`),
}

let isOfferClosed = false;

function main() {

  //  document.addEventListener(`DOMContentLoaded`, e => {
        document.addEventListener(`offer_value_changed_event`, e => {
            DOMElements.loanValue().innerHTML = e.detail.loan.toString().CurrencyFormat(0) + " €";
            DOMElements.splitsValue().innerHTML = e.detail.splits;
            DOMElements.tanValue().innerHTML = e.detail.tan;
            DOMElements.taegValue().innerHTML = e.detail.taeg;
            DOMElements.installmentValue().innerHTML = e.detail.installment.toString().CurrencyFormat(2) + " €";
            DOMElements.startButton().href = e.detail.startUrl;
        });
  //  })

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (isOfferClosed) return;

            DOMElements.mainDiv().classList.toggle(`visible`, !entry.isIntersecting);
        });
    }, {
        threshold: 0
    });
    //observer.observe(DOMElements.closeFlyOfferButton());
    observer.observe(DOMElements.continueButton());

    DOMElements.closeFlyOfferButton().addEventListener(`click`, e => {
        isOfferClosed = true;
        DOMElements.mainDiv().classList.remove(`visible`);
    });
}

main();